<template>
  <div :class="ui.bkgdColor">
    <v-layout row class="ml-2">
      <v-flex xs12>
        <v-icon :color="ui.btnColor"> schedule </v-icon>
        <a :class="ui.textDescription">  {{ dateTypeB(this.selectedDate) }} - </a>
        <a :class="ui.textDescription"> {{ dateTimeAgo(this.selectedDate) }} </a>
      </v-flex>
    </v-layout>
    <v-layout row class="ml-2" v-if = "data.uname !== undefined">
      <v-flex xs12>
        <v-icon :color="ui.btnColor"> person </v-icon>
        <a :class="ui.textDescription"> {{data.uname}} </a>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import dateFunctions from "@/data/functions/mixins/dateFunctions.js";
import apptheme from "@/frame/theme/mixins/apptheme.js";

export default {
  props: {
    data: {
      type: Object
    }
  },
  data() {
    return {
      valid: true
    };
  },
  mixins: [dateFunctions, apptheme],
  computed: {
    // eslint-disable-next-line
    ...mapGetters(["getCurrentPage"]),
    ui() {
      return this.uiTheme1;
    },
    selectedDate() {
      let date = null;
      if (this.data !== null) {
        if (this.data.dedit !== "") {
          date = this.data.dedit;
        } else {
          date = this.data.dcrt;
        }
      }
      return date;
    }
  }
};
</script>
